import type { DfdEmbedUrlOptions } from 'common/dfd-embed-url';

export const DFD_FLOW_KEYS = {
  BOOK_APPOINTMENT: 'book-appointment',
  MY_PROVIDERS: 'my-providers',
} as const;

export type DfdFlowKey = (typeof DFD_FLOW_KEYS)[keyof typeof DFD_FLOW_KEYS];

const NO_TARGET: DfdEmbedUrlOptions = {};

/**
 * League-side flow keys map to the configured TELUS IDs, so the IDs stay in
 * per-environment config and never travel in a URL or a Masonry response. A key
 * resolves to either a flow or a widget — which one is config, not part of the
 * key — and an unknown or unconfigured key opens the default chatbot.
 */
export const getDfdEmbedTarget = (
  flowKey: string | null | undefined,
): DfdEmbedUrlOptions => {
  switch (flowKey) {
    case DFD_FLOW_KEYS.BOOK_APPOINTMENT: {
      const flowId = import.meta.env.VITE_DFD_BOOK_APPOINTMENT_FLOW_ID;
      return flowId ? { flowId } : NO_TARGET;
    }
    case DFD_FLOW_KEYS.MY_PROVIDERS: {
      const widgetId = import.meta.env.VITE_DFD_MY_PROVIDERS_WIDGET_ID;
      return widgetId ? { widgetId } : NO_TARGET;
    }
    default:
      return NO_TARGET;
  }
};
